(() => {
  'use strict';

  if (window.__mainMoreInstantFacets) return;
  window.__mainMoreInstantFacets = true;

  const ROOT = '[data-instant-facets-results]';
  const FORM = '[data-instant-facets-form]';
  let controller = null;
  let priceTimer = null;

  function formUrl(form) {
    const url = new URL(form.action, window.location.href);
    const params = new URLSearchParams();
    for (const [name, rawValue] of new FormData(form).entries()) {
      const value = String(rawValue).trim();
      if (value) params.append(name, value);
    }
    params.delete('page');
    url.search = params.toString();
    return url;
  }

  function openFilters(root) {
    return Array.from(root.querySelectorAll('details[open][data-filter-key]'))
      .map((details) => details.dataset.filterKey);
  }

  function restoreOpenFilters(root, keys) {
    root.querySelectorAll('details[data-filter-key]').forEach((details) => {
      details.open = keys.includes(details.dataset.filterKey);
    });
  }

  function focusDescriptor(root) {
    const active = document.activeElement;
    if (!active || !root.contains(active) || !active.name) return null;
    // Refocusing a replacement native select reopens its picker in iOS Safari.
    // Filters still retain focus after the results are updated.
    if (active.matches('[data-instant-sort]')) return null;
    return {name: active.name, value: active.value, type: active.type};
  }

  function restoreFocus(root, descriptor) {
    if (!descriptor) return;
    const match = Array.from(root.querySelectorAll('[name]')).find((element) =>
      element.name === descriptor.name &&
      (descriptor.type !== 'checkbox' || element.value === descriptor.value)
    );
    if (match) match.focus({preventScroll: true});
  }

  async function updateResults(url, root, pushHistory = true, scrollToTop = false) {
    if (!root) return;
    if (controller) controller.abort();
    controller = new AbortController();
    const request = controller;
    const opened = openFilters(root);
    const focused = focusDescriptor(root);
    const facetsId = root.dataset.instantFacetsId;

    root.classList.add('is-loading');
    root.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url, {
        credentials: 'same-origin',
        headers: {'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest'},
        signal: request.signal,
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = Array.from(page.querySelectorAll(ROOT))
        .find((candidate) => candidate.dataset.instantFacetsId === facetsId);
      if (!replacement) throw new Error('Updated results were not found');

      restoreOpenFilters(replacement, opened);
      root.replaceWith(replacement);
      restoreFocus(replacement, focused);
      if (pushHistory && url.toString() !== window.location.href) {
        history.pushState({mainMoreFacets: true}, '', url);
      }
      if (scrollToTop) requestAnimationFrame(() => window.scrollTo({top: 0, left: 0, behavior: 'instant'}));
    } catch (error) {
      if (error.name === 'AbortError') return;
      window.location.assign(url.toString());
    } finally {
      if (controller === request) controller = null;
      const current = Array.from(document.querySelectorAll(ROOT))
        .find((candidate) => candidate.dataset.instantFacetsId === facetsId);
      if (current) {
        current.classList.remove('is-loading');
        current.setAttribute('aria-busy', 'false');
      }
    }
  }

  function submitForm(form) {
    clearTimeout(priceTimer);
    updateResults(formUrl(form), form.closest(ROOT));
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest(FORM);
    if (!form) return;
    event.preventDefault();
    submitForm(form);
  });

  document.addEventListener('change', (event) => {
    const form = event.target.closest(FORM);
    if (!form) return;
    if (event.target.matches('[data-instant-price]')) {
      submitForm(form);
      return;
    }
    if (event.target.matches('input[type="checkbox"], input[type="radio"], select')) {
      submitForm(form);
    }
  });

  document.addEventListener('input', (event) => {
    const form = event.target.closest(FORM);
    if (!form || !event.target.matches('[data-instant-price]')) return;
    clearTimeout(priceTimer);
    priceTimer = setTimeout(() => submitForm(form), 650);
  });

  document.addEventListener('keydown', (event) => {
    const form = event.target.closest(FORM);
    if (!form || !event.target.matches('[data-instant-price]') || event.key !== 'Enter') return;
    event.preventDefault();
    submitForm(form);
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest(`${ROOT} a`);
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const root = link.closest(ROOT);
    const isPagination = link.matches('.pagination a');
    if (!isPagination && !link.matches('[data-instant-facets-clear]')) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin) return;
    event.preventDefault();
    clearTimeout(priceTimer);
    updateResults(url, root, true, isPagination);
  });

  window.addEventListener('popstate', () => {
    const root = document.querySelector(ROOT);
    if (root) updateResults(new URL(window.location.href), root, false);
  });
})();

